module.exports = __webpack_public_path__ + "img/play-1.1e5ce2fb.png";